<template>
  <div class="settlement-table">
    <div v-for="(item, index) in list" class="month" :key="item.month">
      <div class="title">{{ item.month }}</div>
      <el-table :data="item.periods" :table-key="index" size="mini" style="width: 100%" stripe>
        <el-table-column prop="week" label="全球期次" width="80" />
        <el-table-column prop="week" label="起止日期" header-align="center">
          <template slot-scope="{row}">
            <span>{{ row.start }} ~ {{ row.end }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettlementPeriods',
  data() {
    return {
      year: 2022,
      list: [
        { month: '1月',
          periods: [
            { week: '220103', start: '2022-01-03', end: '2022-01-09' },
            { week: '220110', start: '2022-01-10', end: '2022-01-16' },
            { week: '220117', start: '2022-01-17', end: '2022-01-23' },
            { week: '220124', start: '2022-01-24', end: '2022-01-30' },
            { week: '220131', start: '2022-01-31', end: '2022-02-06' }
          ]
        },
        { month: '2月',
          periods: [
            { week: '220207', start: '2022-02-07', end: '2022-02-13' },
            { week: '220214', start: '2022-02-14', end: '2022-02-20' },
            { week: '220221', start: '2022-02-21', end: '2022-02-27' },
            { week: '220228', start: '2022-02-28', end: '2022-03-06' }
          ]
        },
        { month: '3月',
          periods: [
            { week: '220307', start: '2022-03-07', end: '2022-03-08' },
            { week: '220314', start: '2022-03-14', end: '2022-03-20' },
            { week: '220321', start: '2022-03-21', end: '2022-03-27' },
            { week: '220328', start: '2022-03-28', end: '2022-04-03' },
          ]
        },
        { month: '4月',
          periods: [
            { week: '220404', start: '2022-04-04', end: '2022-04-10' },
            { week: '220411', start: '2022-04-11', end: '2022-04-17' },
            { week: '220418', start: '2022-04-18', end: '2022-04-24' },
            { week: '220425', start: '2022-04-25', end: '2022-05-01' }
          ]
        },
        { month: '5月',
          periods: [
            { week: '220502', start: '2022-05-02', end: '2022-05-08' },
            { week: '220509', start: '2022-05-09', end: '2022-05-15' },
            { week: '220516', start: '2022-05-16', end: '2022-05-22' },
            { week: '220523', start: '2022-05-23', end: '2022-05-29' },
            { week: '220530', start: '2022-05-30', end: '2022-06-05' }
          ]
        },
        { month: '6月',
          periods: [
            { week: '220606', start: '2022-06-06', end: '2022-06-12' },
            { week: '220613', start: '2022-06-13', end: '2022-06-19' },
            { week: '220620', start: '2022-06-20', end: '2022-06-26' },
            { week: '220627', start: '2022-06-27', end: '2022-07-03' },
          ]
        },
        { month: '7月',
          periods: [
            { week: '220704', start: '2022-07-04', end: '2022-07-10' },
            { week: '220711', start: '2022-07-11', end: '2022-07-17' },
            { week: '220718', start: '2022-07-18', end: '2022-07-24' },
            { week: '220725', start: '2022-07-25', end: '2022-07-31' }
          ]
        },
        { month: '8月',
          periods: [
            { week: '220801', start: '2022-08-01', end: '2022-08-07' },
            { week: '220808', start: '2022-08-08', end: '2022-08-14' },
            { week: '220815', start: '2022-08-15', end: '2022-08-21' },
            { week: '220822', start: '2022-08-22', end: '2022-08-28' },
            { week: '220829', start: '2022-08-29', end: '2022-09-04' }
          ]
        },
        { month: '9月',
          periods: [
            { week: '220905', start: '2022-09-05', end: '2022-09-11' },
            { week: '220912', start: '2022-09-12', end: '2022-09-18' },
            { week: '220919', start: '2022-09-19', end: '2022-09-25' },
            { week: '220926', start: '2022-09-26', end: '2022-10-02' }
          ]
        },
        { month: '10月',
          periods: [
            { week: '221003', start: '2022-10-03', end: '2022-10-09' },
            { week: '221010', start: '2022-10-10', end: '2022-10-16' },
            { week: '221017', start: '2022-10-17', end: '2022-10-23' },
            { week: '221024', start: '2022-10-24', end: '2022-10-30' },
            { week: '221031', start: '2022-10-31', end: '2022-11-06' }
          ]
        },
        { month: '11月',
          periods: [
            { week: '221107', start: '2022-11-07', end: '2022-11-13' },
            { week: '221114', start: '2022-11-14', end: '2022-11-20' },
            { week: '221121', start: '2022-11-21', end: '2022-11-27' },
            { week: '221128', start: '2022-11-28', end: '2022-12-04' },
          ]
        },
        { month: '12月',
          periods: [
            { week: '221205', start: '2022-12-05', end: '2022-12-11' },
            { week: '221212', start: '2022-12-12', end: '2022-12-18' },
            { week: '221219', start: '2022-12-19', end: '2022-12-25' },
            { week: '221226', start: '2022-12-26', end: '2023-01-01' }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.settlement-table {
  display: flex;
  flex-wrap: wrap;
  .month {
    width: calc(33% - 20px);
    padding: 0 10px;
    .title {
      height: 40px;
      line-height: 40px;
      background-color: #3e4f6a;
      color: #FFFFFF;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
